"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var usePriceValidation = function (prices) {
    var priceDisplay = usePlatformConfig_1.default().platformConfig.priceDisplay;
    var hasSecondaryCurrency = react_1.useCallback(function () { return !!priceDisplay.secondary; }, [priceDisplay]);
    var hasDifferentCurrencies = react_1.useCallback(function () { var _a; return priceDisplay.primary.currency !== ((_a = priceDisplay.secondary) === null || _a === void 0 ? void 0 : _a.currency); }, [
        priceDisplay,
    ]);
    var isMultiCurrency = react_1.useMemo(function () { return hasSecondaryCurrency() && hasDifferentCurrencies(); }, [priceDisplay, prices]);
    return { isMultiCurrency: isMultiCurrency };
};
exports.default = usePriceValidation;
